// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aBau9brIAG0shbk3hFg8{align-items:center;gap:4px;display:flex}.RP4uiQUYIygazesAlYXF{justify-content:flex-end;align-items:flex-end;display:flex}.DKh5MdJNnRQQaciXTezI{color:var(--content-primary-tertiary);text-align:center;cursor:pointer;margin-left:4px;font-size:14px;display:flex}.DKh5MdJNnRQQaciXTezI.rD2yVxbqrMUo5tHjENpo{color:var(--content-negative-primary)}.DKh5MdJNnRQQaciXTezI.VMXh06XS_ygppuWFCHMi{color:var(--content-brand-primary)}.fMyuxXtBHo0HHlMVVyYh{word-break:normal}.SexDDBH5zwKvCUpgzjzE{color:var(--content-primary-tertiary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"date": `aBau9brIAG0shbk3hFg8`,
	"wrap": `RP4uiQUYIygazesAlYXF`,
	"status": `DKh5MdJNnRQQaciXTezI`,
	"failed": `rD2yVxbqrMUo5tHjENpo`,
	"delivered": `VMXh06XS_ygppuWFCHMi`,
	"wordBreakNormal": `fMyuxXtBHo0HHlMVVyYh`,
	"time": `SexDDBH5zwKvCUpgzjzE`
};
export default ___CSS_LOADER_EXPORT___;
